export class BooleanFilter {
    public equal?: boolean;
}
